export enum TicketSelectionPhase {
  SELECT_DEPARTURE = 0,
  SELECT_RETURN = 1,
}
